import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import LiveBroadcastControl from '@/types/table/liveBroadcastControl';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface LiveBroadcastControlData extends LiveBroadcastControl {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class LiveBroadcastControlController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<LiveBroadcastControlData>>(API_CONTEXT + '/app/liveBroadcastControl/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<LiveBroadcastControlData>(API_CONTEXT + '/app/liveBroadcastControl/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/liveBroadcastControl/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/liveBroadcastControl/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/liveBroadcastControl/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveBroadcastControl/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveBroadcastControl/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveBroadcastControl/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/liveBroadcastControl/deleteBatch', params, httpOptions);
  }
}
